/* tslint:disable */
/* eslint-disable */
/**
 * Calvin Risk API
 * TBD
 *
 * The version of the OpenAPI document: 6.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { ConversationalAgentProtocolEnum } from './ConversationalAgentProtocolEnum';
import {
  ConversationalAgentProtocolEnumFromJSON,
  ConversationalAgentProtocolEnumFromJSONTyped,
  ConversationalAgentProtocolEnumToJSON,
} from './ConversationalAgentProtocolEnum';
import type { CredentialRead } from './CredentialRead';
import { CredentialReadFromJSON, CredentialReadFromJSONTyped, CredentialReadToJSON } from './CredentialRead';

/**
 *
 * @export
 * @interface ConversationalAgentInferencerOpenAIAssistant
 */
export interface ConversationalAgentInferencerOpenAIAssistant {
  /**
   *
   * @type {number}
   * @memberof ConversationalAgentInferencerOpenAIAssistant
   */
  readonly id: number;
  /**
   *
   * @type {string}
   * @memberof ConversationalAgentInferencerOpenAIAssistant
   */
  name?: string | null;
  /**
   *
   * @type {ConversationalAgentProtocolEnum}
   * @memberof ConversationalAgentInferencerOpenAIAssistant
   */
  protocol: ConversationalAgentProtocolEnum;
  /**
   *
   * @type {CredentialRead}
   * @memberof ConversationalAgentInferencerOpenAIAssistant
   */
  readonly credential: CredentialRead;
  /**
   *
   * @type {Date}
   * @memberof ConversationalAgentInferencerOpenAIAssistant
   */
  timestamp?: Date;
  /**
   *
   * @type {string}
   * @memberof ConversationalAgentInferencerOpenAIAssistant
   */
  assistantId: string;
}

/**
 * Check if a given object implements the ConversationalAgentInferencerOpenAIAssistant interface.
 */
export function instanceOfConversationalAgentInferencerOpenAIAssistant(
  value: object,
): value is ConversationalAgentInferencerOpenAIAssistant {
  if (!('id' in value) || value['id'] === undefined) return false;
  if (!('protocol' in value) || value['protocol'] === undefined) return false;
  if (!('credential' in value) || value['credential'] === undefined) return false;
  if (!('assistantId' in value) || value['assistantId'] === undefined) return false;
  return true;
}

export function ConversationalAgentInferencerOpenAIAssistantFromJSON(
  json: any,
): ConversationalAgentInferencerOpenAIAssistant {
  return ConversationalAgentInferencerOpenAIAssistantFromJSONTyped(json, false);
}

export function ConversationalAgentInferencerOpenAIAssistantFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean,
): ConversationalAgentInferencerOpenAIAssistant {
  if (json == null) {
    return json;
  }
  return {
    id: json['id'],
    name: json['name'] == null ? undefined : json['name'],
    protocol: ConversationalAgentProtocolEnumFromJSON(json['protocol']),
    credential: CredentialReadFromJSON(json['credential']),
    timestamp: json['timestamp'] == null ? undefined : new Date(json['timestamp']),
    assistantId: json['assistant_id'],
  };
}

export function ConversationalAgentInferencerOpenAIAssistantToJSON(
  value?: Omit<ConversationalAgentInferencerOpenAIAssistant, 'id' | 'credential'> | null,
): any {
  if (value == null) {
    return value;
  }
  return {
    name: value['name'],
    protocol: ConversationalAgentProtocolEnumToJSON(value['protocol']),
    timestamp: value['timestamp'] == null ? undefined : value['timestamp'].toISOString(),
    assistant_id: value['assistantId'],
  };
}
